<script setup lang="ts">
import { onMounted, ref } from 'vue';
import {
  loadCmBaseCodeOptions,
  type CmBaseCodeOption,
} from '../../composables/cmBaseCodeOptions';

const model = defineModel<string>({ default: '' });

const props = withDefaults(
  defineProps<{
    mainCode: 'B04' | 'B05' | 'B15' | 'B08';
    label: string;
    readOnly?: boolean;
    clearable?: boolean;
    error?: boolean;
    dataRequiredKey?: string;
    requiredMark?: boolean;
  }>(),
  {
    readOnly: false,
    clearable: true,
    error: false,
    dataRequiredKey: '',
    requiredMark: false,
  },
);

const options = ref<CmBaseCodeOption[]>([]);

onMounted(async () => {
  try {
    options.value = await loadCmBaseCodeOptions(props.mainCode);
  } catch (e) {
    console.warn(`[CmBaseCodeAutocomplete] ${props.mainCode} load failed`, e);
  }
});
</script>

<template>
  <v-autocomplete
    v-model="model"
    :items="options"
    item-title="title"
    item-value="value"
    variant="outlined"
    density="compact"
    hide-details="auto"
    :readonly="!!readOnly"
    :clearable="clearable"
    :error="error"
    :data-required-key="dataRequiredKey || undefined"
    :class="{ 'ad-required-field': requiredMark }"
    auto-select-first
  >
    <template v-if="requiredMark" #label>
      {{ label }} <span class="ad-required-mark">*</span>
    </template>
    <template v-else #label>
      {{ label }}
    </template>
  </v-autocomplete>
</template>

<style scoped>
.ad-required-mark {
  color: #b3261e;
}
</style>
